module.exports = __webpack_public_path__ + "static/media/like-svg.42763507.svg";